import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate,currencyFormat, roundOfTwoDecimal } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { ModuleAccess } from 'utils/moduleaccess';

const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        hidecolFilter: true,
        action: true
    },
    {
        dataField: 'createdDate',
        text: 'Captured Date',
        sort: false,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter:true,
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'dateRXWritten',
        text: 'Written Date',
        sort: false,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter:true,
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      // {
      //   dataField: 'writtenDate',
      //   text: 'Written Date',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'date',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      //   showColumn: true
      // },
      {
        dataField: 'dateOfDispense',
        text: 'Date Of Service',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'gwClaimId',
        text: 'Claim ID',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'prescriptionNumber',
        text: 'Rx #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'fillNumber',
        text: 'Refill #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'claimQty',
        text: 'Units Replenished',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter:true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'quantity',
        text: 'Units Dispensed',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'packages',
        text: 'Packages Dispensed',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter:true,
        cellRenderer: (rowData, col) => roundOfTwoDecimal(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: "packageSize",
        text: "Package Size",
        sort: false,
        width: 140,
        show: true,
        inputType: "number",
        cellRenderer: (rowData,col) => cellRendererCheck(rowData[col.dataField]),
        hideColFilter: true,
      },

    {
        dataField: "ndc",
        text: "NDC",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (rowData,col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: "drugName",
        text: "Drug Name",
        sort: false,
        width: 280,
        show: true,
        inputType: "text",
        cellRenderer: (rowData,col) => cellRendererCheck(rowData[col.dataField]),
        hideColFilter: true,
      },
     {
        dataField: 'prescriberFirstName',
        text: 'Prescriber First Name',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter:true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'prescriberLastName',
        text: 'Prescriber Last Name',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter:true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      {
        dataField: 'prescriberNPI',
        text: 'Prescriber NPI',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter:true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      // {
      //   dataField: 'sourceType',
      //   text: 'Source Type',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'storeName',
      //   text: 'StoreName',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
    
      // {
      //   dataField: 'serviceIDorQualifier',
      //   text: 'ServiceIDorQualifier',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'daysSupply',
      //   text: 'DaysSupply',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'primaryBIN',
      //   text: 'PrimaryBIN',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'primaryPCN',
      //   text: 'PrimaryPCN',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'primaryGroupNumber',
      //   text: 'PrimaryGroupNumber',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'secondaryBIN',
      //   text: 'SecondaryBIN',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'secondaryPCN',
      //   text: 'SecondaryPCN',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'secondaryGroup',
      //   text: 'SecondaryGroup Number',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'groupResponseID',
      //   text: 'GroupResponseID',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'otherCoverageCode',
      //   text: 'OtherCoverageCode',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'submissionClarificationCode',
      //   text: 'SubmissionClarificationCode',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'memberID',
      //   text: 'MemberID',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'memberFirstName',
      //   text: 'MemberFirstName',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'memberLastName',
      //   text: 'MemberLastName',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'memberDOB',
      //   text: 'MemberDOB',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'memberGender',
      //   text: 'MemberGender',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'prescriberDEA',
      //   text: 'PrescriberDEA',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'prescriberNPI',
      //   text: 'PrescriberNPI',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
     
      // {
      //   dataField: 'patientPaidAmount',
      //   text: 'PatientPaidAmount',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'planPaidAmount',
      //   text: 'PlanPaidAmount',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'incentiveAmount',
      //   text: 'IncentiveAmount',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'ingredientCost',
      //   text: 'IngredientCost',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'uandC',
      //   text: 'U && C',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'otherRecognizedPaidAmount',
      //   text: 'OtherRecognizedPaidAmount',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'claimSourceID',
      //   text: 'ClaimSourceID',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'claimSourceDate',
      //   text: 'ClaimSourceDate',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'transactionID',
      //   text: 'TransactionID',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'transactionCode',
      //   text: 'TransactionCode',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'transactionResponseStatus',
      //   text: 'TransactionResponseStatus',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'compoundCode',
      //   text: 'CompoundCode',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'text',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'authorizationNumber',
      //   text: 'AuthorizationNumber',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'number',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      // {
      //   dataField: 'clinicID',
      //   text: 'ClinicID',
      //   sort: false,
      //   width: 140,
      //   show: true,
      //   inputType: 'number',
      //   hideColFilter:true,
      //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      //   showColumn: true
      // },
      {
        dataField: 'storeNPI',
        text: 'PharmacyNPI',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter:true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
      },
      

    
];

const ClaimDetailsTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    const [hasExportPermission, setHasExportPermission] = useState(false);
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    useEffect(() => {
      setHasExportPermission(ModuleAccess("PO", "POCLAIMEXP"));
    }, []);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='inventory-table'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasScrollArrow={false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            filters={colFilter}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            onSearchColumnFilters={handleSearchColumnFilters}
            hasExportPermission={hasExportPermission}
        />
    </div>;
};

export default ClaimDetailsTable;
